import { splitScreenColors, STORAGE_KEYS } from './constants';
import { ENUM_ITEM_TYPES, ENUM_STATUS } from './enums';

export const statusIsReady = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.READY;
export const statusIsStarted = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.STARTED;
export const statusIsPending = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.PENDING;
export const statusIsPackaging = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.PACKAGING;
export const statusIsCompleted = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.COMPLETED;
export const statusIsRejected = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.REJECTED;
export const statusIsDispatch = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.DISPATCH;
export const statusIsSearch = (status: ENUM_STATUS): boolean => status === ENUM_STATUS.SEARCH;

export const statusIsReadyOrDispatch = (status: ENUM_STATUS): boolean =>
  status === ENUM_STATUS.READY || status === ENUM_STATUS.DISPATCH;
export const statusIsPackagingOrStarted = (status: ENUM_STATUS): boolean =>
  status === ENUM_STATUS.PACKAGING || status === ENUM_STATUS.STARTED;

export const statusIsReadyDispatchOrPending = (status: ENUM_STATUS): boolean =>
  status === ENUM_STATUS.READY || status === ENUM_STATUS.DISPATCH || status === ENUM_STATUS.PENDING;
export const statusIsCompletedDispatchOrSearch = (status: ENUM_STATUS): boolean =>
  status === ENUM_STATUS.COMPLETED ||
  status === ENUM_STATUS.DISPATCH ||
  status === ENUM_STATUS.SEARCH;

export const getOrderCardStyle = ({
  itemType,
  filterKey,
  isPackagingRole
}: {
  itemType: string | undefined;
  filterKey: string | undefined;
  isPackagingRole: boolean;
}) => {
  return (itemType === ENUM_ITEM_TYPES.SHOP && filterKey === ENUM_ITEM_TYPES.FOOD) ||
    (itemType === ENUM_ITEM_TYPES.FOOD && filterKey === ENUM_ITEM_TYPES.SHOP) ||
    (itemType === ENUM_ITEM_TYPES.SHOP && isPackagingRole)
    ? 'hidden'
    : '';
};

export const getDocketTextStyle = ({
  status,
  isAdminRole
}: {
  status: ENUM_STATUS;
  isAdminRole: boolean;
}) => {
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME) ?? '';

  if (statusIsReady(status)) return 'text-[#D50000]';
  if (statusIsStarted(status)) return 'text-[#D58300]';
  if (statusIsPackaging(status) && isAdminRole) return 'text-[#D58300]';
  if (statusIsPackaging(status) && firstName !== 'Packaging') return 'text-style';
  if (statusIsPackaging(status) && firstName === 'Packaging') return 'text-[#D58300]';
  if (statusIsCompletedDispatchOrSearch(status)) return 'text-[#b9b9b9]';
  if (statusIsRejected(status)) return 'text-white';

  return 'text-[#46AE31]';
};

export const getDocketIconColor = ({
  status,
  isAdminRole
}: {
  status: ENUM_STATUS;
  isAdminRole: boolean;
}) => {
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME) ?? '';
  const adminPackaging = isAdminRole && statusIsPackaging(status);
  const isPackaging = statusIsPackaging(status) && firstName === 'Packaging';

  const isPendingColor = adminPackaging || statusIsStarted(status) || isPackaging;

  if (statusIsReady(status)) return 'text-[#D50000]';
  if (isPendingColor) return 'text-[#D58300]';
  if (statusIsPackaging(status) && firstName !== 'Packaging') return 'text-style';
  if (statusIsCompletedDispatchOrSearch(status)) return 'text-[#707160]';
  if (statusIsRejected(status)) return 'text-white';

  return 'text-[#46AE31]';
};

export const getDocketSplitColor = ({
  status,
  isPackagingRole
}: {
  status: ENUM_STATUS;
  isPackagingRole: boolean;
}) => {
  const staffNumber = localStorage.getItem(STORAGE_KEYS.STAFF_NUMBER);
  const isPackaging = isPackagingRole && statusIsPackaging(status);

  // eslint-disable-next-line
  return isPackaging && staffNumber ? splitScreenColors[+staffNumber - 1] : '';
};

export const isItemTypeFood = (itemType: string): boolean => itemType === ENUM_ITEM_TYPES.FOOD;

export const isItemTypeShop = (itemType: string): boolean => itemType === ENUM_ITEM_TYPES.SHOP;

export const isItemTypeAll = (itemType: string): boolean => itemType === ENUM_ITEM_TYPES.ALL;

export const getPackagingStatus = ({
  status,
  isPackagingRole,
  isShopRole
}: {
  status: ENUM_STATUS;
  isPackagingRole: boolean;
  isShopRole: boolean;
}): boolean =>
  (isPackagingRole && statusIsPackaging(status)) || (isShopRole && statusIsStarted(status));

export const getShouldShowCheckbox = ({
  status,
  showCheckbox
}: {
  status: ENUM_STATUS;
  showCheckbox: boolean;
}) => showCheckbox && statusIsPackagingOrStarted(status);

export const getCanFinishOrder = ({
  status,
  canFinishOrder
}: {
  status: ENUM_STATUS;
  canFinishOrder: boolean;
}) => canFinishOrder && statusIsPackaging(status);

export const getCanViewAddressDetails = ({
  pickup,
  canViewAddressDetails
}: {
  pickup: boolean;
  canViewAddressDetails: boolean;
}) => canViewAddressDetails && !pickup;
